import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import shoutu from './modules/shoutu'
import account from './modules/account'
import dashboard from './modules/dashboard'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    user,
    shoutu,
    account,
    dashboard
  }
})
